<template>
  <div>
    <panel title="提款信息">
      <form-build-component
        class="formTable"
        :form-data="financingDetail"
        :form-columns="financingDetailColumns"
      />
    </panel>
    <panel title="放款信息">
      <form-build-component
        class="formTable"
        :form-data="paymentDetail"
        :form-columns="paymentDetailColumns"
      />
    </panel>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import Panel from "../../../components/Panel";
  import FormBuildComponent from "../../../components/FormBuild";
  import Status2CN from "../../../filters/Status2CN";
  import moment from 'moment'

  export default {
    name: "FinancePaymentDetail",
    components: {FormBuildComponent, Panel},
    data() {
      return {
        fi__transactionId: this.$route.query['fi.transactionId'],
        financingDetail: {},
        financingDetailColumns: [
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '贷款状态',
            field: 'fi__transactionStatus',
            formatter: function (r,v) {
              return Status2CN('Financing_'+v)
            }
          },
          {
            label: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            label: '客户手机号',
            field: 'i__contactTelNo'
          },
          {
            label: '贷款开始日期',
            field: 'fi__startDate'
          },
          {
            label: '贷款结束日期',
            field: 'fi__endDate'
          },
          {
            label: '贷款利率',
            field: 'fi__interestRate',
            formatter: function (r,v) {
              return v + '% (' + Status2CN(r.fi__interestType) + ')'
            }
          },
          {
            label: '服务费',
            field: 'fi__lendingFee',
            unit: '元'
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            unit: '元'
          },
          {
            label: '利息',
            field: 'bal__interestAmount',
            formatter: function (r,v) {
              return v+'元 (至'+r.bal__repayDate+ ')'
            }
          },
          {
            label: '贷款用途',
            field: 'fi__intendedUse'
          },
          {
            label: '未还金额',
            field: 'bal__principalAmount',
            unit: '元'
          },
        ],
        paymentDetail: {},
        paymentDetailColumns: [
          {
            label: '流水号',
            field: 'pay__reference'
          },
          {
            label: '放款状态',
            unit: '放款完成'
          },
          {
            label: '放款类型',
            field: 'pay__cashier',
            formatter: function (r,v) {
              return v == 'SYSTEM' ? '自动放款' : '人工放款'
            }
          },
          {
            label: '放款金额',
            field: 'pay__totalAmount',
            unit: '元'
          },
          {
            label: '放款方式',
            field: 'pay__channel'
          },
          {
            label: '放款时间',
            field: 'pay__payDate',
            formatter: function (r,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            label: '放款人',
            field: 'pay__cashier',
            formatter: function (r,v) {
              return v
            }
          },
          {

          },
          {
            label: '放款账户',
            field: 'cj__cj__outboundAccountDesc',
            span: 24
          },
          {
            label: '收款账户',
            field: 'cj__inboundAccountDesc',
            span: 24
          },
        ]
      }
    },
    mounted() {
      this.getCustomerFinancingDetail(this.fi__transactionId)
      this.getCustomerPaymentDetail(this.fi__transactionId)
    },
    methods: {
      getCustomerFinancingDetail: function (transactionId) {
        xhr.getCustomerFinancingDetail(
          {
            'fi.transactionId' : transactionId
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.financingDetail = res.data.data
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerPaymentDetail: function (transactionId) {
        xhr.getCustomerPaymentList(
          {
            'xlist.search.fi.transactionId' : transactionId,
            'xlist.search.fi.transactionId.op' : 'eq'
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.paymentDetail = res.data.data.shift()
              }
            }catch (e) {
              
            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinancePaymentDetail.vue